import React, { useState } from "react";
import axios from "axios";
import "../assets/expo_landing_page.css";

import vatika from '../assets/imgs/Banner/aatmabodh_vatika.png';

export default function Vatika() {

    const [form, setForm] = useState({
        name: "",
        mobile: "",
        city: "",
        budget: "",
        project: "Aatamabodh Vatika – Donje" // ✅ FIXED
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (form.mobile.length !== 10) {
            alert("Enter valid mobile number");
            return;
        }

        setLoading(true);

        try {
            const res = await axios.post(
                "https://samriddhidevelopers.in/backend/expo_lead.php",
                form,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (res.data.status === "success") {

                const message = `Hi, I am ${form.name}. Interested in Aatamabodh Vatika @ Donje. Budget: ${form.budget}. I want details.`;

                const encoded = encodeURIComponent(message);

                setTimeout(() => {
                    window.location.href = `https://wa.me/919766010099?text=${encoded}`;
                }, 800);

            } else {
                alert("Failed to save lead");
            }

        } catch (err) {
            console.error(err);
            alert("Server error");
        }

        setLoading(false);
    };

    return (
        <div className="expo-page">

            {/* HERO */}
            <section
                className="expo-hero"
                style={{ backgroundImage: `url(${vatika})` }}
            >
                <div className="expo-overlay">
                    <h1 className="expo-heading">
                        Aatamabodh Vatika @ Donje
                    </h1>

                    <p className="expo-sub">
                        A Wellness-Inspired Bungalow Community
                    </p>

                    <button
                        className="expo-primary-btn"
                        onClick={() =>
                            document.getElementById("form").scrollIntoView({ behavior: "smooth" })
                        }
                    >
                        Experience Wellness Living
                    </button>
                </div>
            </section>

            {/* HIGHLIGHTS */}
            <section className="expo-projects">
                <h2 className="section-title">Project Highlights</h2>

                <div className="expo-grid">
                    <div className="expo-card">Wellness-Inspired Living 🌿</div>
                    <div className="expo-card">Near Patanjali Aatambodh 🧘</div>
                    <div className="expo-card">Sinhagad Fort View 🏞️</div>
                    <div className="expo-card">Peaceful Hill Surroundings</div>
                    <div className="expo-card">Ideal for Second Home</div>
                    <div className="expo-card">Fast Developing Location</div>
                </div>
            </section>

            {/* FORM */}
            <section id="form" className="expo-form-section">
                <h2 className="expo-section-title-white">
                    Get Price & Site Visit Details
                </h2>

                <form className="expo-form" onSubmit={handleSubmit}>

                    <input
                        name="name"
                        placeholder="Your Name"
                        onChange={handleChange}
                        required
                    />

                    <input
                        name="mobile"
                        placeholder="Mobile Number"
                        onChange={handleChange}
                        required
                    />

                    <input
                        name="city"
                        placeholder="City"
                        onChange={handleChange}
                        required
                    />

                    <select name="budget" onChange={handleChange} required>
                        <option value="">Select Budget</option>
                        <option>30–50L</option>
                        <option>50–80L</option>
                        <option>80L+</option>
                    </select>

                    <button
                        type="submit"
                        className="expo-primary-btn"
                        disabled={loading}
                    >
                        {loading ? "Submitting..." : "Get Details on WhatsApp"}
                    </button>

                </form>
            </section>

        </div>
    );
}